import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CnpjDirective } from './cnpj';
import { CpfDirective } from './cpf';
import { FocusDirective } from './focus';
import { ShowDirective } from './show';

export const CUSTOM_DIRECTIVES = [CpfDirective, CnpjDirective, FocusDirective, ShowDirective];

@NgModule({
  imports: [CommonModule],
  exports: [CUSTOM_DIRECTIVES],
  declarations: [CUSTOM_DIRECTIVES],
})
export class DirectivesModule {}
